// Fonction pour changer le texte du bouton Next
function changeNextButtonText() {
    var nextButton = document.querySelector('.action.next');
    if (nextButton) {
  
      if (nextButton.innerText == 'Next') {
        nextButton.innerText = 'Suivant';
      } else {
        nextButton.innerText = 'Envoyer';
      }
    }
  }
  
  // Fonction pour changer le texte du bouton Previous
  function changePreviousButtonText() {
    var previousButton = document.querySelector('.action.previous');
    if (previousButton) {
      previousButton.innerText = 'Précédent';
    }
  }
  
    // Appel des fonctions au chargement de la page
    window.onload = function () {
      changeNextButtonText();
      changePreviousButtonText();
  
        // Appel des fonctions lorsque le bouton est cliqué
    document.querySelector('.action.next').addEventListener('click', function () {
      changeNextButtonText();
    });
  
    document.querySelector('.action.previous').addEventListener('click', function () {
      changeNextButtonText();
    });
  };